// extracted by mini-css-extract-plugin
module.exports = {"receipt-settings":"receipt_settings__receipt-settings___2CgdU"};